import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "to", "replace", "onClick"];
import { useMemo, useCallback, createElement } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { createLocation } from 'history';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
const AbstractRouterLink = props => {
  const {
      component,
      to = '',
      replace = false,
      onClick
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const history = useHistory();
  const handleClick = useCallback(e => {
    callIfPossible(onClick, e);
    if (e.defaultPrevented) {
      return;
    }
    if (e && !e.metaKey) {
      e.preventDefault();
      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    }
  }, [history, onClick, replace, to]);
  const href = useMemo(() => {
    const location = typeof to === 'string' || to === null ? createLocation(to || '', null, undefined, history.location) : to;
    return history.createHref(location);
  }, [history, to]);
  return /*#__PURE__*/createElement(component, Object.assign({}, rest, {
    href,
    onClick: handleClick
  }));
};
AbstractRouterLink.propTypes = {
  component: PropTypes.elementType.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  replace: PropTypes.bool
};
export default AbstractRouterLink;